import React from 'react';

const AboutUs: React.FC = () => {
    return (
        <div className="container mx-auto py-8 px-4 max-w-4xl text-gray-900 dark:text-gray-100">
            <h1 className="text-3xl font-bold mb-8 text-center text-amber-700 dark:text-amber-400">À propos de Pépite</h1>

            <div className="flex flex-col gap-8">
                <section className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm p-6 rounded-2xl border border-amber-100 dark:border-amber-900/30 shadow-sm flex flex-col gap-4">
                    <h2 className="text-xl font-semibold mb-4 text-amber-600 dark:text-amber-400 border-b border-amber-100 dark:border-amber-900/30 pb-2">Qui suis-je ?</h2>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        Bonjour ! Je suis un <strong>développeur indépendant</strong> passionné, et j'ai créé Pépite seul avec une intention simple :
                        simplifier la découverte de marques qui ont du sens.
                    </p>
                </section>

                <section className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm p-6 rounded-2xl border border-amber-100 dark:border-amber-900/30 shadow-sm flex flex-col gap-4">
                    <h2 className="text-xl font-semibold mb-4 text-amber-600 dark:text-amber-400 border-b border-amber-100 dark:border-amber-900/30 pb-2">La Mission de Pépite</h2>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        Pépite est né de la volonté de mettre en avant des <strong>marques indépendantes</strong> et des créateurs qui privilégient
                        la qualité, l'originalité et des valeurs fortes. Dans un monde dominé par les géants de la fast-fashion et de la grande distribution,
                    </p>
                </section>

                <section className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm p-6 rounded-2xl border border-amber-100 dark:border-amber-900/30 shadow-sm flex flex-col gap-4">
                    <h2 className="text-xl font-semibold mb-4 text-amber-600 dark:text-amber-400 border-b border-amber-100 dark:border-amber-900/30 pb-2">Un Projet Communautaire</h2>
                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        Ce projet est fait <strong>pour la communauté</strong>. Mon objectif est de fournir un outil utile, agréable et transparent :
                    </p>
                    <ul className="list-none space-y-3">
                        <li className="flex items-center gap-3">
                            <span className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold">✓</span>
                            <span className="text-gray-700 dark:text-gray-300"><strong>Hébergement local :</strong> Toutes vos données restent sur un serveur sécurisé, hébergé en <strong>Suisse</strong>.</span>
                        </li>
                        <li className="flex items-center gap-3">
                            <span className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold">✓</span>
                            <span className="text-gray-700 dark:text-gray-300"><strong>Confidentialité totale :</strong> Aucune donnée n'est transmise à des tiers. Votre vie privée est respectée à 100%.</span>
                        </li>
                        <li className="flex items-center gap-3">
                            <span className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold">✓</span>
                            <span className="text-gray-700 dark:text-gray-300"><strong>Entièrement gratuit :</strong> Accès illimité à toutes les fonctionnalités.</span>
                        </li>
                        <li className="flex items-center gap-3">
                            <span className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold">✓</span>
                            <span className="text-gray-700 dark:text-gray-300"><strong>Sans publicité :</strong> Une expérience pure, sans interruption ni pollution visuelle.</span>
                        </li>
                        <li className="flex items-center gap-3">
                            <span className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold">✓</span>
                            <span className="text-gray-700 dark:text-gray-300"><strong>Indépendant :</strong> Aucune affiliation cachée, les recommandations sont basées sur vos goûts.</span>
                        </li>
                    </ul>
                </section>

                <section className="text-center py-8">
                    <p className="text-gray-600 dark:text-gray-400 italic">
                        Merci de faire partie de l'aventure Pépite et de soutenir les créateurs indépendants.
                    </p>
                </section>
            </div>

            <p className="text-center text-sm text-gray-400 dark:text-gray-500 mt-8 border-t border-amber-100 dark:border-amber-900/30 pt-4">
                Développé avec ❤️
            </p>
        </div>
    );
};

export default AboutUs;
